import merge from 'lodash.merge';

class Modal {

  constructor (settings = {}) {

    settings = merge({
      title: '',
      content: '',
      classes: [],
      maxWidth: 800,
      showNav: false,
      navIndex: 0,
      navList: [],
      onClose: null,
    }, settings);

    this.settings = settings;
    this.modal = document.createElement('div');
    this.modal.classList.add('modal');

    this.currentIndex = this.settings.navIndex;
    this.navList = this.settings.navList;

    settings.classes.map(c => {
      this.modal.classList.add(c);
    });

    this.modal.innerHTML = `
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-header__title">${settings.title}</h2>
        <button type="button" class="modal__close"><i class="fal fa-times"></i></button>
      </div>
      <div class="modal__content"></div>
      ${this.settings.showNav ? `
        <button type="button" class="modal-nav-previous ${this.currentIndex > 0 ? 'is-active' : ''}"></button>
        <button type="button" class="modal-nav-next ${this.currentIndex + 1 < this.navList.length ? 'is-active' : ''}"></button>
      `: ''}
    </div>    
    `;

    this.modalContainer = this.modal.querySelector('.modal-content');

    this.title = this.modal.querySelector('.modal-header__title');
    this.content = this.modal.querySelector('.modal__content');

    this.closeButton = this.modal.querySelector('.modal__close');

    if(this.settings.content.length > 0) {
      this.setContent(this.settings.content);
    }

    if(this.settings.showNav && this.settings.navList.length > 0) {

      this.prevButton = this.modal.querySelector('.modal-nav-previous');
      this.nextButton = this.modal.querySelector('.modal-nav-next');

      this.prevButton.addEventListener('click', this.previousItem.bind(this));
      this.nextButton.addEventListener('click', this.nextItem.bind(this));

    }

    this.closeButton.addEventListener('click', () => {
      this.close();
    });

    this.modal.addEventListener('mousedown', e => {
      if(e.target === this.modal) {
        this.close();
      }
    });

    document.addEventListener('keyup', this.onKeyUpEvent.bind(this));
    document.body.appendChild(this.modal);

  }

  updateContentToNavItem() {

    if(this.navList.length > 0 && this.navList[this.currentIndex]) {

      const item = this.navList[this.currentIndex];
      this.setTitle(item.title);
      this.setContent(item.content);

    }

  }

  previousItem() {
    if(this.currentIndex > 0) {

      this.currentIndex--;
      this.nextButton.classList.toggle('is-active', true);

      if(this.currentIndex === 0) {
        this.prevButton.classList.remove('is-active');
      } else {
        this.prevButton.classList.toggle('is-active', true);
      }

      this.updateContentToNavItem();

    }
  }

  nextItem() {

    if(this.currentIndex + 1 < this.navList.length) {

      this.currentIndex++;
      this.prevButton.classList.toggle('is-active', true);

      if(this.currentIndex === this.navList.length - 1) {
        this.nextButton.classList.remove('is-active');
      } else {
        this.nextButton.classList.toggle('is-active', true);
      }

      this.updateContentToNavItem();

    }
  }

  onKeyUpEvent(e) {

    if(e.key === 'Escape') {
      this.close();
    }
  }

  getContainer() {
    return this.modal;
  }

  setTitle(html) {
    this.title.innerHTML = html;
  }

  getContentContainer() {
    return this.modalContainer;
  }

  setContent(html) {

    this.content.innerHTML = html;

    if(window.lazyImages) {
      window.lazyImages.maybeProcessItems(this.content);
    }

    this.offsetContainer();

  }

  offsetContainer() {

    $(this.modal).css('top', window.scrollY + 'px');

    const offset = (window.innerHeight / 2) - (this.modalContainer.offsetHeight / 2) - 100;

    if(offset + this.modalContainer.offsetHeight < window.innerHeight) {

      $(this.modalContainer).css('marginTop', offset + 'px');
    } else {
      $(this.modalContainer).css('marginTop', '0px');
    }

  }

  open() {

    // remember page position
    this.startPagePosition = $(window).scrollTop();

    this.modal.classList.add('is-open');

    if(this.settings.maxWidth) {
      $(this.modalContainer).css('maxWidth', this.settings.maxWidth + 'px');
    }

    document.body.classList.toggle('has-modal', true);
    this.offsetContainer();

  }

  close() {

    if(this.settings.onClose) {
      this.settings.onClose();
    }

    document.removeEventListener('keyup', this.onKeyUpEvent.bind(this));

    if(Array.from(document.body.childNodes).includes(this.modal)) {
      document.body.removeChild(this.modal);
      document.body.classList.toggle('has-modal', false);
    }

    // put us back
    $(window).scrollTop(this.startPagePosition)

  }

}

export default Modal;
